module.exports = __webpack_public_path__ + "img/ico_4.fb46b738.svg";